module.exports = __webpack_public_path__ + "static/media/Finnovex-Qatar-2024.41253a3a.png";